module.exports = __webpack_public_path__ + "img/T6-C-xh_14.a28046aa.png";